import axios from "axios";

export interface IStreamhubClent {
    getEndpoint: () => string;
    postObject: (
        object: Record<string, string | number | Date | boolean | object>,
        path: string,
        responseHandler: (arg0: unknown) => void,
        errorHandler: (arg0: unknown) => void
    ) => Promise<void>;
}

export class StreamhubClient implements IStreamhubClent {
    private readonly endpoint: string =
        process.env["NODE_ENV"] === "production"
            ? "https://www.atlassian.com/endpoint"
            : "https://wac.stg.internal.atlassian.com/endpoint";

    public getEndpoint() {
        return this.endpoint;
    }

    public async postObject(
        object: Record<string, string | number | Date | boolean | object>,
        path: string,
        responseHandler: (arg0: unknown) => void,
        errorHandler?: (arg0: unknown) => void
    ) {
        try {
            const response = await axios.post(
                `${this.endpoint}/streamhub/${path}`,
                object
            );
            responseHandler(response);
        } catch (error) {
            console.error("Failed to post object to endpoint", error);
            if (errorHandler) {
                errorHandler(error);
            }
            throw error;
        }
    }
}
